import { render, staticRenderFns } from "./mediaAssets.vue?vue&type=template&id=3ddca878&scoped=true&"
import script from "./mediaAssets.vue?vue&type=script&lang=js&"
export * from "./mediaAssets.vue?vue&type=script&lang=js&"
import style0 from "./mediaAssets.vue?vue&type=style&index=0&id=3ddca878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddca878",
  null
  
)

export default component.exports